var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendRequest = function SvgSendRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241,
    height: 170,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "send-request_svg__a",
    width: 241,
    height: 217,
    x: 0,
    y: -30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-29.503h240.515V187H0V-29.503Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.1,
    strokeWidth: 6,
    mask: "url(#send-request_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.522 60.571v24.153c0 7.737 6.969 14.01 15.565 14.01h19.455c2.15 0 3.892 1.568 3.892 3.503V118.3c0 3.119 4.19 4.683 6.643 2.476L72.423 99.76c.73-.657 1.72-1.026 2.751-1.026h76.213c8.595 0 15.563-6.273 15.563-14.01V.658c0-7.737-6.968-14.01-15.564-14.01h-132.3c-8.595 0-15.564 6.273-15.564 14.01v47.228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.797 147.772h-42.67c-8.595 0-15.563-6.273-15.563-14.01v-33.276M166.951 35.687h54.476c8.596 0 15.565 6.272 15.565 14.01v84.065c0 7.737-6.969 14.01-15.565 14.01h-19.455c-2.149 0-3.891 1.568-3.891 3.503v16.062c0 3.121-4.192 4.684-6.643 2.477l-23.347-21.016c-.73-.657-1.719-1.026-2.752-1.026h-19.448M128.039 119.75c0 3.868-3.484 7.005-7.782 7.005s-7.782-3.137-7.782-7.005c0-3.869 3.484-7.005 7.782-7.005s7.782 3.136 7.782 7.005ZM93.019 77.718c0 3.869-3.484 7.005-7.782 7.005s-7.783-3.136-7.783-7.005c0-3.868 3.485-7.005 7.783-7.005s7.782 3.137 7.782 7.005ZM85.237 56.703c-4.298 0-7.782-3.137-7.782-7.006v-7.005c0-6.417 4.213-12.12 10.735-14.531 3.11-1.15 5.042-3.961 4.809-6.997-.26-3.397-3.42-6.242-7.194-6.476-2.189-.134-4.282.526-5.876 1.864-1.596 1.34-2.475 3.16-2.475 5.124 0 3.868-3.484 7.005-7.782 7.005s-7.782-3.137-7.782-7.005c0-5.804 2.704-11.405 7.419-15.366C74.021 2.35 80.42.308 86.877.71c11.546.717 20.854 9.097 21.65 19.49.695 9.067-5.102 17.475-14.424 20.921-.649.24-1.084.87-1.084 1.57v7.006c0 3.87-3.484 7.006-7.782 7.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08 119.75c0 3.868-3.484 7.005-7.782 7.005s-7.782-3.137-7.782-7.005c0-3.869 3.484-7.005 7.782-7.005s7.782 3.136 7.782 7.005ZM163.059 119.749c0 3.869-3.484 7.006-7.782 7.006-4.299 0-7.783-3.137-7.783-7.006 0-3.868 3.484-7.005 7.783-7.005 4.298 0 7.782 3.137 7.782 7.005Z"
  }))));
};
export default SvgSendRequest;